<template>
    <div>
        <slot
            :closeDialog="closeDialog"
            :formattedDate="formattedDate"
            :imageUrl="imageUrl"
        >
        </slot>
    </div>
</template>

<script>
'use strict'

import { format } from 'date-fns';
import { computed, defineComponent, inject } from 'vue';

export default defineComponent({
    name: 'CalendarPopup',
    props: {
        event: {
            type: Object,
        }
    },
    setup(props) {
        const imageUrl = inject('imageUrl');

        const formattedDate = computed(() => {
            if (props.event && Object.keys(props.event).length) {
                return format(props.event.performancedate, 'EEE, MMM d');
            }
        });

        const closeDialog = (() => {
            const dialog = document.getElementById('calendar-popup');
            dialog.close()
        });

        return {
            closeDialog,
            formattedDate,
            imageUrl,
        }
    }
});
</script>
